<section fxFlex fxlayout="row" class="countrypagebg countryguidedetailpg">

    <mat-progress-bar class="iwg-navbar-progress" color="accent" mode="indeterminate" *ngIf="this.isLoading">
    </mat-progress-bar>

    <div fxLayout="column" fxLayoutAlign="space-between" fxFlex class="countryguide-content countryguide-content-width" >
        <div class="padding">
            <div class="iwg-page-header-breadcrumb">
                <a [routerLink]="['/myGuides']">MyGuides</a> » <span class="iwg-page-header-small-title">
                    {{this.countryGuide?.CountryTitle}}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="iwg-page-header-toolbar-reduced" fxLayout="row" fxLayoutAlign="center center">
                <button mat-button class="mat-icon-button" [routerLink]="['/myGuides']">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                <div class="iwg-page-header-title">{{this.countryGuide?.CountryTitle}}</div>
                <span fxFlex></span>
            </div>
           
            <div class="content">
                <app-country-guide [countryGuide]="countryGuide"></app-country-guide>
            </div>
        </div>
        <div *ngIf="showFooter" class="innerpage-footer">
            <app-iwg-footer [blurBg]="true"></app-iwg-footer>
        </div>
    </div>


    <mat-sidenav class="iwg-country-guide-detail-sidenav mobileimghide" [ngStyle]="this.countryGuide && {'background-image': 'url'+'(' +
    ((this.countryGuide?.Region.ImageURL!=null)?this.countryGuide?.Region.ImageURL:this.countryGuide?.Country.ImageURL)
     + ')','background-position':'center','background-size':'cover'}">


    </mat-sidenav>

</section>